module.exports = __webpack_public_path__ + "static/serp.3ab4862d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/vendors/serp.png
// module id = 663
// module chunks = 172845445241205